import { useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import type { TarefaDeleteEscopo, TarefaDto, TarefaTipo } from "@/services/tarefas";
import { cn } from "@/utils/cn";

interface ModalExcluirRecorrenteProps {
  open: boolean;
  tarefa: TarefaDto | null;
  busy?: boolean;
  onClose: () => void;
  onConfirm: (escopo: TarefaDeleteEscopo) => void | Promise<void>;
}

const OPTIONS: Array<{ value: TarefaDeleteEscopo; label: string }> = [
  { value: "esta", label: "Esta tarefa" },
  { value: "desta_em_diante", label: "Esta e as seguintes" },
  { value: "todas", label: "Todas as tarefas" },
];

function labelsForTipo(tipo: TarefaTipo) {
  if (tipo === "evento") {
    return {
      title: "Excluir evento recorrente",
      esta: "Este evento",
      seguintes: "Este e os eventos seguintes",
      todas: "Todos os eventos",
    };
  }
  return {
    title: "Excluir tarefa recorrente",
    esta: "Esta tarefa",
    seguintes: "Esta e as tarefas seguintes",
    todas: "Todas as tarefas",
  };
}

export function ModalExcluirRecorrente({
  open,
  tarefa,
  busy = false,
  onClose,
  onConfirm,
}: ModalExcluirRecorrenteProps) {
  const [escopo, setEscopo] = useState<TarefaDeleteEscopo>("esta");
  const tipo = tarefa?.tipo ?? "tarefa";
  const L = labelsForTipo(tipo);

  const optionLabels: Record<TarefaDeleteEscopo, string> = {
    esta: L.esta,
    desta_em_diante: L.seguintes,
    todas: L.todas,
  };

  const handleConfirm = async () => {
    await onConfirm(escopo);
    setEscopo("esta");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={L.title}
      size="sm"
      footer={
        <div className="flex w-full justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={busy}>
            Cancelar
          </Button>
          <Button loading={busy} onClick={() => void handleConfirm()}>
            OK
          </Button>
        </div>
      }
    >
      <div className="space-y-2">
        {OPTIONS.map((opt) => (
          <label
            key={opt.value}
            className={cn(
              "flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 transition-colors",
              escopo === opt.value
                ? "border-blue-400 bg-blue-50/60"
                : "border-slate-200 hover:bg-slate-50",
            )}
          >
            <input
              type="radio"
              name="escopo-exclusao"
              checked={escopo === opt.value}
              onChange={() => setEscopo(opt.value)}
              className="h-4 w-4 border-slate-300 text-blue-600 focus:ring-blue-500"
            />
            <span className="text-sm text-slate-700">{optionLabels[opt.value]}</span>
          </label>
        ))}
      </div>
    </Modal>
  );
}
